import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

// Target enum
export enum ExternalCredentialTarget {
  CREFIA = 'CREFIA',
  // 추후 다른 외부 인증 대상 추가 가능
}

// Status enum
export enum ExternalCredentialStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

// ExternalIdPasswordCredential 기반 인터페이스
export interface ExternalIdPasswordCredential {
  id: number;
  companyId: string;
  target: ExternalCredentialTarget;
  loginId: string;
  status: ExternalCredentialStatus;
  createdAt?: string;
  updatedAt?: string;
}

// API 요청 타입
export interface ExternalIdPasswordCredentialRequest {
  target: ExternalCredentialTarget;
  loginId: string;
  password: string;
}

// API functions using ExternalIdPasswordCredential endpoints
export function createExternalIdPasswordCredential(
  companyId: string,
  request: ExternalIdPasswordCredentialRequest,
) {
  return API.post<ResponseBaseWithData<ExternalIdPasswordCredential>>(
    `/api/v2/companies/${companyId}/external-id-password-credentials`,
    {
      data: request,
    },
  );
}

export function getExternalIdPasswordCredentials(companyId: string) {
  return API.get<ResponseBaseWithData<ExternalIdPasswordCredential[]>>(
    `/api/v2/companies/${companyId}/external-id-password-credentials`,
  );
}

export function deleteExternalIdPasswordCredential(companyId: string, credentialId: number) {
  return API.delete(
    `/api/v2/companies/${companyId}/external-id-password-credentials/${credentialId}`,
  );
}
